import { Link } from 'react-router-dom';

interface JobLinkProps {
  jobId: string | number;
  label?: string | number;
  projectUuid: string;
  target?: string;
}

export default function JobLink({
  label,
  projectUuid,
  jobId,
  target = '_self',
}: JobLinkProps) {
  return (
    <Link to={`/project_details/${projectUuid}?jobId=${jobId}`} target={target}>
      {label || jobId}
    </Link>
  );
}
